export default __webpack_public_path__ + "static/media/SharePercentageIcon.222aff79.svg";